import { Alert, AlertIcon, Text, Link } from '@chakra-ui/core';
import Sparkles from "../../../../src/components/Sparkles";
import * as React from 'react';
export default {
  Alert,
  AlertIcon,
  Text,
  Link,
  Sparkles,
  React
};